
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import theme from '../../theme';

const ModalHeader = (props) => {
  const { title, type, handleClose } = props;
  
  return (
    <>
      <Typography
        variant="h4"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          height: type === 'fullHeight' ? '56px' : '40px',
          margin: 0,
          padding: '0 40px',                
          borderBottom: `1px solid ${theme.palette.grey.w300}`,
          boxSizing: 'borderBox'
        }}
      >
        { title }
        <CloseOutlinedIcon
          sx={{
            cursor: 'pointer'
          }}
          onClick={handleClose}
        />
      </Typography>
    </>
  )
}

export default ModalHeader;